import React from "react";

const MarkSheetFormatFour = ({ marksheet }) => {
  const {
    report_info,
    done_subjects = [],
    marks_collection = {}
  } = marksheet || {};

  const { format_id, title } = report_info || {};
  const formatId = Number(format_id);
  const studentInfo = marks_collection?.student_info || [];

  const SubjectHeadRow = ({ subject }) => (
    <>
      {subject?.done_papers?.map((paper, idx) => (
        <td key={idx}>{paper.paper_code}</td>
      ))}
      <td>{formatId === 2 ? "Id" : "GD"}</td>
    </>
  );

  const StudentMarkRow = ({ student, index }) => {
    const studentId = student.id;
    const studentData = marks_collection?.[studentId] || {};
    const { total, position } = studentData;

    return (
      <tr key={studentId}>
        <td>{index + 1}</td>
        <td>{student.full_name}</td>

        {done_subjects.map((subject, idx) => {
          const subjectId = subject.subject_info?.subject_id;
          const subjectMarks = studentData?.[subjectId] || {};
          const mark =
            subjectMarks?.summative_plus_formative?.[subjectId] ?? "-";
          const grade = subjectMarks?.normal_grade?.[subjectId]?.grade ?? "-";

          return (
            <React.Fragment key={idx}>
              {subject?.done_papers?.map((_, i) => (
                <td key={i} style={{ textAlign: "center" }}>
                  {mark}
                </td>
              ))}
              <td
                style={
                  grade !== "-"
                    ? {
                        backgroundColor: "#000000",
                        color: "#FFFFFF",
                        fontWeight: "bold",
                        textAlign: "center",
                      }
                    : { textAlign: "center" }
                }
              >
                {grade}
              </td>
            </React.Fragment>
          );
        })}

        <td style={{ textAlign: "center", fontWeight: "bold" }}>{total}</td>
        <td style={{ textAlign: "center", fontWeight: "bold" }}>{studentData?.average}</td>
        <td style={{ textAlign: "center", fontWeight: "bold" }}>
          {position?.position}
        </td>
      </tr>
    );
  };

  if (!Array.isArray(studentInfo)) return null;

  return (
    <table
      width="100%"
      border="1"
      className="Reports"
      style={{ fontSize: "12px" }}
      cellSpacing="0"
      cellPadding="0"
    >
      <caption>{title}</caption>
      <thead>
        <tr>
          <th>NO</th>
          <th>NAMES</th>
          {done_subjects.map((subject, idx) => (
            <th
              key={idx}
              colSpan={(subject.total_papers || 0) + 1}
              style={{ textAlign: "center" }}
            >
              {subject.subject_info?.abbreviation}
            </th>
          ))}
          <th style={{ textAlign: "center" }}>TOTAL</th>
          <th style={{ textAlign: "center" }}>AV SC</th>
          <th style={{ textAlign: "center" }}>Identifier</th>
        </tr>
      </thead>
      <tbody>
        <tr
          style={{
            backgroundColor: "#000000",
            color: "#FFFFFF",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          {done_subjects.map((subject, idx) => (
            <SubjectHeadRow key={idx} subject={subject} />
          ))}
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
        </tr>

        {studentInfo.map((student, index) => (
          <StudentMarkRow key={student.id} student={student} index={index} />
        ))}
      </tbody>
    </table>
  );
};

export default MarkSheetFormatFour;
